import { BlockElementTypes, BlockTypes } from '@pm2/course-builder';
import { AddToCourseBuilder } from '@pm2/ui-components';
import { configRefs } from '@utils/constants';
import { button } from './add-to-course-builder.style.js';
import { jsx } from 'react/jsx-runtime';

function AddResourceToCourseBuilder({
  resource
}) {
  if (!resource.src) {
    return null;
  }
  const baseProps = {
    className: button,
    small: true,
    withoutOverlay: true
  };
  switch (resource.kind) {
    case "InternalLink":
    case "ExternalLink":
    case "Document":
      {
        if (isYoutubeVideoUrl(resource.src)) {
          return /*#__PURE__*/jsx(AddToCourseBuilder, {
            ...baseProps,
            block: {
              type: BlockTypes.YOUTUBE,
              id: resource.id,
              title: resource.title,
              videoUrl: resource.src
            }
          });
        }
        const href = resource.kind === "Document" ? `${configRefs.apis.pm2.media.dangerouslyAssertSyncValue()}${resource.src}` : resource.src;
        return /*#__PURE__*/jsx(AddToCourseBuilder, {
          ...baseProps,
          block: {
            type: BlockTypes.LINK,
            id: resource.id,
            title: resource.title,
            href
          }
        });
      }
    case "ContentElement":
      {
        const blockElementType = mapComponentTypeToBlockElementType(resource.componentType);
        if (!blockElementType) {
          return null;
        }
        return /*#__PURE__*/jsx(AddToCourseBuilder, {
          ...baseProps,
          block: {
            type: BlockTypes.REFERENCE,
            element: {
              id: resource.src,
              title: resource.title,
              type: blockElementType
            }
          }
        });
      }
    case "Page":
      {
        return /*#__PURE__*/jsx(AddToCourseBuilder, {
          ...baseProps,
          block: {
            type: BlockTypes.REFERENCE,
            element: {
              id: resource.src,
              title: resource.title,
              type: BlockElementTypes.PAGE
            }
          }
        });
      }
    default:
      return null;
  }
}
function isYoutubeVideoUrl(videoUrl) {
  return /(youtu\.be\/|youtube\.com\/(watch)?\?vi?=)([a-zA-Z0-9_-]{11})/.test(videoUrl ?? "");
}
function mapComponentTypeToBlockElementType(componentType) {
  switch (componentType) {
    case "audio":
      return BlockElementTypes.AUDIO;
    case "image":
      return BlockElementTypes.IMAGE;
    case "iframe":
      return BlockElementTypes.IFRAME;
    case "text":
    case "richtext":
      return BlockElementTypes.RICHTEXT;
    case "video":
      return BlockElementTypes.VIDEO;
  }
}

export { AddResourceToCourseBuilder };
//# sourceMappingURL=add-to-course-builder.js.map
